import { render, staticRenderFns } from "./OptionRule.vue?vue&type=template&id=5e6cee36&scoped=true&"
import script from "./OptionRule.vue?vue&type=script&lang=ts&"
export * from "./OptionRule.vue?vue&type=script&lang=ts&"
import style0 from "./OptionRule.vue?vue&type=style&index=0&id=5e6cee36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6cee36",
  null
  
)

export default component.exports